import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DEFAULT_MASS_MAX, DEFAULT_MASS_MIN, DEFAULT_LAYERS, } from "@erikwatson/snowfall";
import { Control } from "../../../control/control";
import { useDispatch } from "react-redux";
import { Range } from "../../../range/range";
import { setMassMax, setMassMin, } from "../../../../features/config/config.slice";
import { ControlGroup } from "../../../controlGroup/controlGroup";
import { Group } from "../../../group/group";
export const SnowflakeMass = ({ index, layer }) => {
    const dispatch = useDispatch();
    return (_jsx(_Fragment, { children: _jsx(Group, { colour: "grey-2", name: "Mass", children: _jsxs(ControlGroup, { children: [_jsx(Control, { name: "Minimum", tooltip: "The minimum mass of the snowflakes", showOutput: true, reset: () => {
                            const min = index < DEFAULT_LAYERS.length
                                ? DEFAULT_LAYERS[index].mass.min
                                : DEFAULT_MASS_MIN;
                            dispatch(setMassMin({
                                index,
                                min,
                            }));
                        }, value: layer.mass.min, onChange: (event) => dispatch(setMassMin({
                            index,
                            min: Number(event.target.value),
                        })), children: _jsx(Range, { min: "0", max: "10", step: "1" }) }), _jsx(Control, { name: "Maximum", tooltip: "The maximum size of the snowflakes", showOutput: true, reset: () => {
                            const max = index < DEFAULT_LAYERS.length
                                ? DEFAULT_LAYERS[index].mass.max
                                : DEFAULT_MASS_MAX;
                            dispatch(setMassMax({
                                index,
                                max,
                            }));
                        }, value: layer.mass.max, onChange: (event) => dispatch(setMassMax({
                            index,
                            max: Number(event.target.value),
                        })), children: _jsx(Range, { min: "0", max: "10", step: "1" }) })] }) }, index) }));
};
